export default "__VITE_ASSET__DdoWd8O4__"